app.AppearanceListView = app.BaseListView.extend({
  title: 'Appearances',

  createCell(model) {
    const cell = app.BaseListView.prototype.createCell.apply(this, arguments);

    if (app.sessionUser.canManageMenu() && !app.location) {
      const $dupeButton = cell.addButtonWithClass('dupe btn-primary', () => {
        const reqId = $dupeButton.initLoadingButton('Dupe', 'Duping');
        const data = {
          name: `${model.get('name')} (Copy)`,
          originalAppearanceId: model.id,
        };

        const newModel = new this.collection.model(
          {},
          {
            collection: this.collection,
          },
        );
        newModel.save(data, {
          error() {
            $dupeButton.loadingDidFinishWithError(reqId);
          },
          success: () => {
            $dupeButton.loadingDidFinishSuccessfully(reqId);
            this.collection.add(newModel);
          },
        });
        return false;
      });
      $dupeButton.html('Dupe');
    }

    return cell;
  },
});
